import { render, staticRenderFns } from "./GlobalExplorerDialog.vue?vue&type=template&id=54e07b32&scoped=true"
import script from "./GlobalExplorerDialog.vue?vue&type=script&lang=js"
export * from "./GlobalExplorerDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalExplorerDialog.vue?vue&type=style&index=0&id=54e07b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e07b32",
  null
  
)

export default component.exports